module.exports = __webpack_public_path__ + "img/no_recent_visits.5f637835.svg";